import { Monitor, Moon, Sun } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from './cn';
import { type ThemePreference, useTheme } from './use-theme';

const OPTIONS: { value: ThemePreference; label: string; icon: typeof Sun }[] = [
	{ value: 'light', label: 'Light', icon: Sun },
	{ value: 'dark', label: 'Dark', icon: Moon },
	{ value: 'system', label: 'System', icon: Monitor },
];

/**
 * Перемикач теми на три положення.
 *
 * «System» — окреме значення, а не відсутність вибору: користувач, який його
 * обрав, має й далі слідувати за системою, коли та перемкнеться ввечері.
 */
export function ThemeToggle({ className }: { className?: string }): ReactNode {
	const theme = useTheme();

	return (
		<div
			role="radiogroup"
			aria-label="Colour theme"
			/*
			  Без межі: сегменти розрізняються заливкою активного, а групу для
			  читачів екрана підписують role="radiogroup" і aria-label.
			*/
			className={cn('flex rounded-full bg-surface-muted p-0.75', className)}
		>
			{OPTIONS.map((option) => {
				const active = theme.preference === option.value;
				return (
					<button
						key={option.value}
						type="button"
						role="radio"
						aria-checked={active}
						aria-label={`${option.label} theme`}
						title={`${option.label} theme`}
						onClick={() => theme.setPreference(option.value)}
						className={cn(
							'grid size-7.5 place-items-center rounded-full transition-colors',
							active ? 'bg-surface text-fg shadow-e1' : 'text-fg-subtle hover:text-fg',
						)}
					>
						<option.icon className="size-3.5" />
					</button>
				);
			})}
		</div>
	);
}
